import script from "./UiSimpleCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiSimpleCell.vue?vue&type=script&setup=true&lang=ts"

import "./UiSimpleCell.vue?vue&type=style&index=0&id=8f75500a&lang=css"

const __exports__ = script;

export default __exports__